import React, { Component } from 'react';
import Spinner from 'react-spinner-material'
import { HorizontalBar } from 'react-chartjs-2'
import { HistoryService } from '../../app/historyService'

const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    layout: {
        padding: {
            left: 10,
            right: 20,
            top: 10,
            bottom: 10
        }
    },
    scales: {
        xAxes: [{
            gridLines: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: false
            },
            ticks: {
                beginAtZero: true,
                fontColor: '#6B7280',
                fontSize: 11,
                padding: 5
            }
        }],
        yAxes: [{
            gridLines: {
                display: false
            },
            ticks: {
                beginAtZero: true,
                fontColor: '#374151',
                fontSize: 12,
                padding: 10
            },
            // Synced bar thickness
            barPercentage: 0.7,
            categoryPercentage: 0.8
        }]
    },
    tooltips: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        titleFontSize: 13,
        bodyFontSize: 12,
        xPadding: 12,
        yPadding: 10,
        cornerRadius: 8,
        displayColors: false
    },
    onClick: (event, elements) => {
        if (elements[0] !== undefined) {
            const chart = elements[0]._chart;
            const element = chart.getElementAtEvent(event)[0]
            HistoryService.sendData('/inspections', { employeeData: element._model.label })
        }
    }
}

// Synced color pattern
const baseColors = [
    '#3B82F6', // Blue
    '#6366F1', // Indigo
    '#8B5CF6', // Purple
    '#A855F7', // Violet
    '#C084FC', // Light Purple
];

export class EmployeeChart extends Component {

    render() {
        const { data: employeeData } = this.props

        if (!employeeData) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} />
                </div>
            )
        }

        if (employeeData.length === 0) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    color: '#9CA3AF',
                    fontSize: '14px'
                }}>
                    Sem dados
                </div>
            )
        }

        // Limit to top 15 employees (synced with CategoryChart)
        const limitedData = employeeData.slice(0, 15);

        // Map colors (gradient)
        const colors = limitedData.map((_, index) => baseColors[index % baseColors.length]);
        const hoverColors = colors.map(c => c + 'CC');

        const dataChart = {
            labels: limitedData.map(d => {
                // Truncate long names
                const name = d.label || '';
                return name.length > 25 ? name.substring(0, 25) + '...' : name;
            }),
            datasets: [{
                label: 'Inspeções',
                backgroundColor: colors,
                borderColor: 'transparent',
                borderWidth: 0,
                hoverBackgroundColor: hoverColors,
                data: limitedData.map(d => d.qtt),
                borderRadius: 4,
                barThickness: 'flex',
                maxBarThickness: 28,
                minBarLength: 4
            }]
        };

        // Synced dynamic height calculation
        const dynamicHeight = Math.max(300, limitedData.length * 40);

        return (
            <div style={{ height: `${dynamicHeight}px`, width: '100%' }}>
                <HorizontalBar
                    data={dataChart}
                    options={options}
                />
            </div>
        )
    }
}
